export default "__VITE_ASSET__BpiYhDdn__"